import { render, staticRenderFns } from "./VpayAccountOrder.vue?vue&type=template&id=74c6a702&scoped=true"
import script from "./VpayAccountOrder.vue?vue&type=script&lang=js"
export * from "./VpayAccountOrder.vue?vue&type=script&lang=js"
import style0 from "./VpayAccountOrder.vue?vue&type=style&index=0&id=74c6a702&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c6a702",
  null
  
)

export default component.exports